export const credentials = {
  apiKey: "AIzaSyDMs5sjh4ubvDJWZPXoQLA8Q4mYhjfLCK8",
  authDomain: "marine-broker-test.firebaseapp.com",
  projectId: "marine-broker-test",
  storageBucket: "marine-broker-test.firebasestorage.app",
  messagingSenderId: "1060331866535",
  appId: "1:1060331866535:web:a250fecbba8ae8f0370e82",
  measurementId: "G-NWRYV0F7VM"
};